import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Asks the left menu to reload after a change made in the frontend itself, e.g. saved project settings.
 * The menu reloads only when the currently selected project is one of the given projects.
 */
@Injectable({ providedIn: 'root' })
export class IrisLeftMenuRefreshService {
  private readonly projectIdsSubject = new Subject<number[]>();

  readonly projectIds$: Observable<number[]> = this.projectIdsSubject.asObservable();

  refreshForProjects(projectIds: number[]): void {
    this.projectIdsSubject.next(projectIds);
  }
}
